import React from 'react';
import ColorInput from 'component/atom/forms/colorInput/ColorInput';
import UploadFile from 'component/atom/forms/uploadInput/UploadInput';
import Select from 'component/atom/forms/select/select/Select';
import styles from '../Branding.module.scss';

function MainPageContent({
  values,
  setFieldValue,
  handleUploadChange,
  errors,
  touched,
}) {
  const fontStyleOptions = [
    {
      value: 'Montserrat',
      label: 'Montserrat',
    },
    {
      value: 'Poppins',
      label: 'Poppins',
    },
    {
      value: 'Roboto',
      label: 'Roboto',
    },
    {
      value: 'Raleway',
      label: 'Raleway',
    },
  ];

  return (
    <div
      className={`${styles.contentContainer} ${styles.mainContentContainer}`}
    >
      <div className={styles.row}>
        <div className={styles.item}>
          <h3 className={styles.rowTitle}>Sidebar</h3>
        </div>
      </div>
      <div className={styles.row}>
        <div className={`${styles.item} ${styles['upload-container']}`}>
          <UploadFile
            label={'Side Bar Logo'}
            name={'sideBarLogo'}
            inputID="sideBarLogo"
            placeholder="Upload Side Bar Logo"
            isImage
            onChange={handleUploadChange}
            image={values.SideBarLogo}
            imageContentType={values.SideBarLogoContentType}
            handleRemoveTempLogin={() => {
              setFieldValue('SideBarLogo', null);
              setFieldValue('SideBarLogo_Delete', true);
            }}
          />
        </div>
        <div className={`${styles.item} ${styles['upload-container']}`}>
          <UploadFile
            label={'Mobile Logo'}
            name={'mobileLogoView'}
            inputID="mobileLogoView"
            placeholder="Upload Mobile Logo"
            isImage
            onChange={handleUploadChange}
            image={values.MobileLogo}
            imageContentType={values.MobileLogoContentType}
            handleRemoveTempLogin={() => {
              setFieldValue('MobileLogo', null);
              setFieldValue('MobileLogo_Delete', true);
            }}
          />
        </div>
      </div>
      <div className={styles['sidebar-input-container']}>
        <div className={styles['sidebar-group']}>
          <span className={styles['sidebar-group-title']}>Default:</span>
          <div className={styles['sidebar-input-group']}>
            <ColorInput
              label={'Background Color'}
              value={values.SideBar_BackgroundColor}
              onChange={(e) =>
                setFieldValue('SideBar_BackgroundColor', e.target.value)
              }
              error={errors.SideBar_BackgroundColor}
              touched={touched.SideBar_BackgroundColor}
            />
            <ColorInput
              label={'Text Color'}
              value={values.SideBar_TextColor}
              onChange={(e) =>
                setFieldValue('SideBar_TextColor', e.target.value)
              }
              error={errors.SideBar_TextColor}
              touched={touched.SideBar_TextColor}
            />
          </div>
        </div>
        <div className={styles['sidebar-group']}>
          <span className={styles['sidebar-group-title']}>Active:</span>
          <div className={styles['sidebar-input-group']}>
            <ColorInput
              label={'Background Color'}
              value={values.SideBar_Active_BackgroundColor}
              onChange={(e) =>
                setFieldValue('SideBar_Active_BackgroundColor', e.target.value)
              }
              error={errors.SideBar_Active_BackgroundColor}
              touched={touched.SideBar_Active_BackgroundColor}
            />
            <ColorInput
              label={'Text Color'}
              value={values.SideBar_Active_TextColor}
              onChange={(e) =>
                setFieldValue('SideBar_Active_TextColor', e.target.value)
              }
              error={errors.SideBar_Active_TextColor}
              touched={touched.SideBar_Active_TextColor}
            />
          </div>
        </div>

        <div className={styles['sidebar-group']}>
          <span className={styles['sidebar-group-title']}>Hover:</span>
          <div className={styles['sidebar-input-group']}>
            <ColorInput
              label={'Background Color'}
              value={values.SideBar_Hover_BackgroundColor}
              onChange={(e) =>
                setFieldValue('SideBar_Hover_BackgroundColor', e.target.value)
              }
              error={errors.SideBar_Hover_BackgroundColor}
              touched={touched.SideBar_Hover_BackgroundColor}
            />
            <ColorInput
              label={'Text Color'}
              value={values.SideBar_Hover_TextColor}
              onChange={(e) =>
                setFieldValue('SideBar_Hover_TextColor', e.target.value)
              }
              error={errors.SideBar_Hover_TextColor}
              touched={touched.SideBar_Hover_TextColor}
            />
          </div>
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.item}>
          <h3 className={styles.rowTitle}>Page</h3>
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.item}>
          <Select
            label="Font Style"
            placeholder="Select Font Style"
            name="fontStyle"
            value={values.Page_FontStyle}
            options={fontStyleOptions}
            onChange={(e) => setFieldValue('Page_FontStyle', e.target.value)}
          />
        </div>
        <div className={styles.item}>
          <ColorInput
            label={'Background Color'}
            value={values.Page_BackgroundColor}
            onChange={(e) =>
              setFieldValue('Page_BackgroundColor', e.target.value)
            }
            error={errors.Page_BackgroundColor}
            touched={touched.Page_BackgroundColor}
          />
        </div>
        <div className={styles.item}>
          <ColorInput
            label={'Text Color'}
            value={values.Page_TextColor}
            onChange={(e) => setFieldValue('Page_TextColor', e.target.value)}
            error={errors.Page_TextColor}
            touched={touched.Page_TextColor}
          />
        </div>
        <div className={styles.item}>
          <ColorInput
            label={'Button Color'}
            value={values.Page_ButtonColor}
            onChange={(e) => setFieldValue('Page_ButtonColor', e.target.value)}
            error={errors.Page_ButtonColor}
            touched={touched.Page_ButtonColor}
          />
        </div>
      </div>
    </div>
  );
}

export default MainPageContent;
